import { useEffect, useState } from 'react';

export const useLandscapeArtifact = (isMobileDevice: boolean, artifactActivated: boolean, hasArtifact: boolean) => {
  const [landscapeArtifact, setLandscapeArtifact] = useState(false);

  useEffect(() => {
    if (!isMobileDevice) return;

    const mql = window.matchMedia('(orientation: landscape)');
    if (mql.matches && artifactActivated) {
      setLandscapeArtifact(true);
    } else {
      setLandscapeArtifact(false);
    }

    const handleChange = (e: MediaQueryListEvent) => {
      if (e.matches && hasArtifact) {
        setLandscapeArtifact(true);
      } else if (!e.matches) {
        setLandscapeArtifact(false);
      }
    };

    mql.addEventListener('change', handleChange);
    return () => mql.removeEventListener('change', handleChange);
  }, [hasArtifact, isMobileDevice, artifactActivated]);

  useEffect(() => {
    if (isMobileDevice && !landscapeArtifact) {
      document.documentElement.setAttribute('data-portrait-lock', '');
    } else {
      document.documentElement.removeAttribute('data-portrait-lock');
    }
    return () => document.documentElement.removeAttribute('data-portrait-lock');
  }, [isMobileDevice, landscapeArtifact]);

  return { landscapeArtifact, setLandscapeArtifact } as const;
};
